module.exports = __webpack_public_path__ + "d78d0e4a.svg";